<template>
  <div class="error">
     <transition name="fade">
        <p v-show="show">{{title}}</p>
    </transition>
  </div>
</template>

<script>
export default {
  data(){
    return {
      show:true
    }
  },
  props:{
    title:{
      type:String,
      default:'2312'
    },
    type:{
      type:String,
      default:'error'
    },
    time:{
      type:Number,
      default:1000
    }
  },
  mounted(){
    setTimeout(()=>{
      this.show=false   
    },this.time - 200)
    setTimeout(()=>{
      this.show=false
      this.remove()     
    },this.time)
  }
}
</script>

<style scoped>
    .error{position: fixed;text-align: center;top: 50%;width: 100%;z-index: 10;}
    .error p{background-color: rgba(0, 0, 0, 0.5);color: #fff;display: inline;padding: 1vw 3vw;border-radius: 3vw;}
    .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/errorMessage.vue